import { useParams } from 'react-router-dom'
import styles from './Music.module.css'
import Albums from '../Data/albums'

const AlbumPage = () => {
  const { albumSlug } = useParams()

  const album = Albums.find((a) => a.title === albumSlug)

  if (!album) {
    return <p>Album not found</p>
  }

  return (
    <div className={styles.layout}>
      <h1 className={styles.pageTitle}>{album.title}</h1>
      <div className={styles.albumView}>
        <img
          src={album.image}
          alt={album.title}
          className={styles.cover}
        />
        <div className={styles.albumDetails}>
          <p>
            {album.type} · {album.year}
          </p>
          <h2>Tracks</h2>
          <ol>
            {album.tracks.map((track, index) => (
              <li key={index}>{track}</li>
            ))}
          </ol>
          {album.links.platoon ? (
            <h3>
              <a
                href={album.links.platoon}
                target='_blank'
                rel='noreferrer'
                className={styles.streamLink}
              >
                Stream {album.title}
              </a>
            </h3>
          ) : (
            <h2>Stream on: </h2>
          )}

          {!album.links.platoon && (
            <ul className={styles.links}>
              {album.links.spotify && (
                <li>
                  <a
                    href={album.links.spotify}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Spotify
                  </a>
                </li>
              )}
              {album.links.apple && (
                <li>
                  <a
                    href={album.links.apple}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Apple Music
                  </a>
                </li>
              )}
              {album.links.bandcamp && (
                <li>
                  <a
                    href={album.links.bandcamp}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Bandcamp
                  </a>
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default AlbumPage
